const type = 'USER_PREFERENCES';

export const DISABLE_TWO_FACTOR_AUTH_REQUEST = `${type}/DISABLE_TWO_FACTOR_AUTH_REQUEST`;
export const ENABLE_TWO_FACTOR_AUTH_REQUEST = `${type}/ENABLE_TWO_FACTOR_AUTH_REQUEST`;

export const FETCH_USER_PREFERENCES_REQUEST = `${type}/FETCH_USER_PREFERENCES_REQUEST`;
export const FETCH_USER_PREFERENCES_RESPONSE = `${type}/FETCH_USER_PREFERENCES_RESPONSE`;

export const UPDATE_USER_PROFILE_REQUEST = `${type}/UPDATE_USER_PROFILE_REQUEST`;
export const UPDATE_USER_PROFILE_RESPONSE = `${type}/UPDATE_USER_PROFILE_RESPONSE`;

export const USER_PREFERENCES_ERRORS_REQUEST = `${type}/USER_PREFERENCES_ERRORS_REQUEST`;
export const USER_PREFERENCES_ERRORS_RESPONSE = `${type}/USER_PREFERENCES_ERRORS_RESPONSE`;

export const RESET_PASSWORD_REQUEST = `${type}/RESET_PASSWORD_REQUEST`;

export const COPY_TO_CLIPBOARD = `${type}/COPY_TO_CLIPBOARD`;
